import { useSelector } from 'react-redux'

import { CommentType } from 'utils/types'
import StateType from 'utils/types/states'

const selectComments = (state: StateType) => state.comments.comments

export const useRecordComments: () => CommentType[] = () => useSelector(selectComments)
